import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiUrls } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';


@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  constructor(private http: HttpClient, private authenticaton: AuthenticationService,) {
  }

  /** user */
  async getUser(id: string): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return await this.http.get(apiUrls.getUser + id, this.httpJsonOptions(token))
      .toPromise();
  }

  async updateProfilePicture(id: string, profilePicture: any) {
    const token = await this.authenticaton.refreshToken();

    return await this.http.patch(
      apiUrls.getUser + id,
      {
        profilePicture
      },
      this.httpJsonOptions(token, 'application/merge-patch+json')
    )
      .toPromise();
  }

  async updateUser(id: string, body: any) {
    const token = await this.authenticaton.refreshToken();

    return await this.http.patch(
      apiUrls.getUser + id,
      {
        firstName: body.firstname ?? 'string',
        name: body.lastname ?? 'string',
        postalCode: body.postalCode ?? null,
        profilePicture: body.profilePicture ?? null
      },
      this.httpJsonOptions(token, 'application/merge-patch+json')
    )
      .toPromise();
  }

  /** vinyls */
  async vinylsByArtist(id): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.vinylsbyArtist + id, this.httpJsonOptions(token))
      .toPromise();
  }

  async getVinyls(): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.getVinyls, this.httpJsonOptions(token))
      .toPromise();
  }

  async myVinyls(): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.myVinyls, this.httpJsonOptions(token))
      .toPromise();
  }

  async myNewsVinyls(): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.myNewsVinyls, this.httpJsonOptions(token))
      .toPromise();
  }

  async vinyl(id): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.vinyl + id, this.httpJsonOptions(token))
      .toPromise();
  }

  /** artists */
  async getArtists(): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.getArtists, this.httpJsonOptions(token))
      .toPromise();
  }

  async artist(id): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.artist + id, this.httpJsonOptions(token))
      .toPromise();
  }

  async myArtists(): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.myArtists, this.httpJsonOptions(token))
      .toPromise();
  }

  async artistRequest(body): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.post(apiUrls.artistRequest, body, this.httpJsonOptions(token))
      .toPromise();
  }

  async subscribeToArtist(body): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.post(apiUrls.subscribe, body, this.httpJsonOptions(token))
      .toPromise();
  }

  /** posts */
  async postsByArtist(id): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.postsbyArtist + id, this.httpJsonOptions(token))
      .toPromise();
  }

  async myPosts(): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.myPosts, this.httpJsonOptions(token))
      .toPromise();
  }


  async post(id): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.post + id, this.httpJsonOptions(token))
      .toPromise();
  }

  /** qrcode */
  async checkQrcode(id): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.get(apiUrls.checkQrcode + id, this.httpJsonOptions(token))
      .toPromise();
  }

  async activateQrcode(id): Promise<any> {
    const token = await this.authenticaton.refreshToken();
    return this.http.post(apiUrls.activateQrcode, { qrcode: id }, this.httpJsonOptions(token))
      .toPromise();
  }

  /** Fetch file */
  async fetchFile(fileId): Promise<any> {
    return fetch(apiUrls.songApi + fileId);
  }

  /** options */
  private httpJsonOptions(token: string, contentType: string = 'application/json') {
    return {
      headers: new HttpHeaders(
        {
          'Accept': 'application/json',
          'Content-Type': contentType,
          'Authorization': `bearer ${token}`
        }
      )
    };
  };
}